export const seabed = 'seabed';
